import { PDFClause } from '~/lib/pdfViewer/types';
import type { CommentedHighlight } from '~/components/ui/vendor/pdf/pdf_container/types';
import { DocumentChunkFinderResponse } from '~/api/def/endpoints/docCompare/docCompareEndpoint';

export function clausesToPDFHighlights(
  clauses: PDFClause[],
): CommentedHighlight[] {
  const result: CommentedHighlight[] = [];
  for (const clause of clauses) {
    const bbox = clause.sourceBoundingBox;

    for (
      let pageNumber = bbox.pageStart;
      pageNumber <= bbox.pageEnd;
      pageNumber++
    ) {
      const firstPage = pageNumber === bbox.pageStart;
      const lastPage = pageNumber === bbox.pageEnd;
      const pagebbox = {
        pageNumber,
        x1: bbox.x1,
        x2: bbox.x2,
        // Handle span across pages
        y1: firstPage ? bbox.y1 : 0,
        y2: lastPage ? bbox.y2 : 1,

        // Always 0 to 1 for clauses
        height: 1,
        width: 1,
      };
      const highlight: CommentedHighlight = {
        id: firstPage ? clause.clauseId : `${clause.clauseId}-p${pageNumber}`,
        type: 'text',
        content: {},
        position: {
          boundingRect: pagebbox,
          rects: [pagebbox],
        },
        comment: clause.title,
      };
      result.push(highlight);
    }
  }
  return result;
}

export function chunkFinderToPDFHighlights(
  chunks: DocumentChunkFinderResponse[],
): CommentedHighlight[] {
  const result: CommentedHighlight[] = [];
  for (const chunk of chunks) {
    for (
      let pageNumber = chunk.bbox_page_start;
      pageNumber <= chunk.bbox_page_end;
      pageNumber++
    ) {
      const firstPage = pageNumber === chunk.bbox_page_start;
      const lastPage = pageNumber === chunk.bbox_page_end;
      const pagebbox = {
        pageNumber,
        x1: chunk.bbox_x1,
        x2: chunk.bbox_x2,
        // Handle span across pages
        y1: firstPage ? chunk.bbox_y1 : 0,
        y2: lastPage ? chunk.bbox_y2 : 1,

        // Always 0 to 1 for clauses
        height: 1,
        width: 1,
      };
      const highlight: CommentedHighlight = {
        id: firstPage ? chunk.id.toString() : `${chunk.id}-p${pageNumber}`,
        type: 'text',
        content: {},
        position: {
          boundingRect: pagebbox,
          rects: [pagebbox],
        },
        comment: chunk.text,
      };
      result.push(highlight);
    }
  }
  return result;
}
